import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoginOption, ProfileKey } from '../visor.types';

@Component({
  selector: 'app-profile-selection',
  templateUrl: './profile-selection.component.html'
})
export class ProfileSelectionComponent {
  @Input({ required: true }) loginOptions: LoginOption[] = [];
  @Input({ required: true }) profileIconPaths: Record<ProfileKey, string> = {
    public: '',
    irrigators: '',
    guards: '',
    managers: ''
  };

  @Output() profileSelected = new EventEmitter<LoginOption>();

  protected getProfileIconPath(profile: ProfileKey): string {
    return this.profileIconPaths[profile];
  }
}
